<template>
  <div class="card_wrap" @click="toDetail(itemData)">
    <div class="question">
      <div class="question_info">
        <div class="question_avatar">
          <!-- 问题头像 -->
          <!-- <img src="@/assets/img/activity/message_hr_def.png" /> -->
          <img :src="itemData.userInfo?.userPortrait" alt="" />
          <img src="@/assets/img/activity/question@3x.png" />
        </div>
        <div class="question_content">
          {{ itemData.description }}
        </div>
      </div>
      <template v-if="itemData.isMyThread && page !== '活动页'">
        <img
          src="@/assets/img/activity/reject@3x.png"
          alt=""
          v-if="itemData.status === -1"
        />
        <img src="@/assets/img/activity/ask@3x.png" alt="" v-else />
      </template>
    </div>
    <div class="resource" v-if="itemData.relationType !== 1 && type == '1'">
      <template v-if="itemData.relationType === 2">
        <img src="@/assets/img/activity/company@3x.png" />
        <div>
          <span>该问题来自公司</span>
          <span>{{ itemData.companyInfo?.companyName }}</span>
        </div>
      </template>
      <template v-else>
        <img src="@/assets/img/activity/job@3x.png" />
        <div>
          <span>该问题来自职位</span>
          <div class="jobSource">
            <div v-if="itemData.jobInfo?.jobName" class="jobName">
              {{ itemData.jobInfo?.jobName }}
            </div>
            <div v-if="itemData.jobInfo?.provideSalaryString" class="dot">
              ·
            </div>
            <div v-if="itemData.jobInfo?.provideSalaryString" class="jobSalary">
              {{ itemData.jobInfo?.provideSalaryString }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="answer" v-if="itemData.answerTotalCount > 0">
      <div
        class="answer_info"
        v-for="item in itemData.answerList"
        :key="item.id"
      >
        <div class="answer_avatar">
          <!-- 回复头像 -->
          <!-- <img src="@/assets/img/activity/message_hr_def.png" /> -->
          <img :src="item.userInfo?.userPortrait" alt="" />
          <img src="@/assets/img/activity/answer@3x.png" />
        </div>
        <div class="answer_content">
          <div class="answer_user">
            <span>{{ item.userInfo?.userName }}</span>
            <!-- 是否hr -->
            <img
              src="@/assets/img/activity/HR@3x.png"
              v-if="item.userInfo?.userType === 2"
            />
          </div>
          <div class="answer_detail">
            <div class="answer_text">
              {{ item.message }}
            </div>
            <div class="answer_more">
              <span
                >全部{{
                  itemData.answerTotalCount > 99
                    ? "99+"
                    : itemData.answerTotalCount
                }}个回答</span
              >
              <img src="@/assets/img/activity/right@2x.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noanswer" v-else>
      <span>暂无回答</span>
      <div>
        <span>查看详情</span>
        <img src="@/assets/img/activity/right@2x.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "QaCard",
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    page: {
      type: String,
      default: "活动页",
    },
    type: {
      type: String,
      default: "1",
    },
  },
  methods: {
    toDetail(item) {
      if (!this.$base.checkLoginStatus(true)) return;
      const { companyId, jobId, contentId, contentRank } = item.sensorsdata;
      const { activityId, jobSource, componentId, type, id } =
        this.$route.query;
      this.$sensors.track("PostClick", {
        companyId,
        jobId,
        contentId,
        contentRank,
      });
      this.$router.push({
        path: "/questionDetail",
        query: {
          questionId: item.id,
          activityId: activityId || this.$route.params.pageId,
          type: item.relationType,
          jobSource,
          componentId,
          originType: type,
          index: contentRank,
          formPage: this.page,
          id,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.card_wrap {
  margin: 8px;
  margin-top: 0;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  padding-top: 16px;
  .question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > img {
      height: 18px;
      width: auto;
      margin-left: 6px;
    }
    .question_label {
      line-height: 16px;
      background: #e4f5ff;
      border-radius: 4px;
      border: 1px solid #d1efff;
      font-size: 11px;
      color: #0092e0;
      padding: 0 4px;
      margin-left: 4px;
      &.reject {
        background: #eaeaea;
        color: #4e525a;
        border: 1px solid #dfdfdf;
      }
    }
    .question_info {
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      align-items: center;
      flex: 1;
      .question_avatar {
        position: relative;
        & > img {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          margin-right: 7px;
          &:nth-child(2) {
            width: 14px;
            height: 14px;
            border-radius: 4px;
            position: absolute;
            bottom: 0px;
            right: 0px;
          }
        }
        & > span {
          width: 14px;
          height: 14px;
          background: #21b1ff;
          border-radius: 4px;
          font-weight: 600;
          font-size: 10px;
          color: #ffffff;
          line-height: 14px;
          text-align: center;
          display: inline-block;
          position: absolute;
          bottom: 0px;
          right: 5px;
        }
      }
      .question_content {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
        font-size: 16px;
        color: #222222;
      }
    }
  }
  .resource {
    background: #f4f8fb;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    align-items: center;
    margin-top: 8px;
    & > div {
      display: flex;
      align-items: baseline;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      & > span {
        font-weight: 600;
        font-size: 12px;
        color: #222222;
        white-space: nowrap;
      }
      & > span:nth-child(1) {
        font-size: 12px;
        color: #4e525a;
        margin-right: 6px;
        font-weight: 400;
      }
      & > span:nth-child(2) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .jobSource {
        display: flex;
        align-items: center;
        font-weight: 600;
        .dot {
          margin: 0 4px;
        }
        .jobName {
          max-width: 112px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .jobSalary {
          max-width: 84px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    & > img {
      width: 12px;
      height: 12px;
      margin-right: 8px;
    }
  }
  .answer {
    margin-top: 8px;
    .answer_info {
      display: flex;
    }
    .answer_avatar {
      position: relative;
      min-width: 22px;
      height: 22px;
      & > img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 7px;
        &:nth-child(2) {
          width: 14px;
          height: 14px;
          border-radius: 4px;
          position: absolute;
          bottom: 0px;
          right: 0px;
        }
      }
      & > span {
        width: 14px;
        height: 14px;
        background: #ff6c0e;
        border-radius: 4px;
        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        line-height: 14px;
        text-align: center;
        display: inline-block;
        position: absolute;
        bottom: 0px;
        right: 5px;
      }
    }
    .answer_content {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }
    .answer_user {
      font-size: 12px;
      color: #4e525a;
      display: flex;
      align-items: center;
      height: 13px;
      margin-top: 5px;
      & > img {
        height: 13px;
        width: auto;
        margin-left: 5px;
      }
      .hr_label {
        background: linear-gradient(90deg, #e7f6ff 0%, #d6eeff 100%);
        border-radius: 4px;
        border: 1px solid #3c70ff;
        margin-left: 5px;
        font-size: 10px;
        color: #3c70ff;
        padding: 2px 6px;
        line-height: 7px;
      }
    }
    .answer_detail {
      font-weight: 400;
      font-size: 12px;
      color: #222222;
      line-height: 16px;
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      .answer_text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .answer_more {
        font-weight: 400;
        font-size: 12px;
        color: #ff6c0e;
        margin-left: 6px;
        cursor: pointer;
        & > img {
          width: 6px;
          height: auto;
          margin-left: 4px;
        }
      }
    }
  }
  .noanswer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 7px;
    & > span {
      font-size: 12px;
      color: #4e525a;
    }
    & > div {
      font-size: 12px;
      color: #ff6c0e;
      cursor: pointer;
      & > img {
        width: 6px;
        height: auto;
        margin-left: 4px;
      }
    }
  }
}
</style>
